import {useDebugValue, useRef} from 'react';

import classNames from 'classnames';

import {dateUtils} from '@homeaway/react-date-pickers';

import {hasEmptyDate, hasFilledDate} from '../../../utils/dates';

const classNamespace = 'search-form';
const dateDisplayClassName = `${classNamespace}__date-display`;
const dateDisplayEmptyClassName = `${dateDisplayClassName}--empty`;
const dateDisplayNotEmptyClassName = `${dateDisplayClassName}--not-empty`;
const dateDisplayActiveClassName = `${dateDisplayClassName}--active`;

const dateDisplayLabelClassName = `${dateDisplayClassName}-label`;
const dateDisplayValueClassName = `${dateDisplayClassName}-value`;

const transitionEnterClassName = 'enter';
const transitionEnterActiveClassName = 'enter-active';
const transitionExitClassName = 'exit';
const transitionExitActiveClassName = 'exit-active';

function useComponent(props) {
    const {
        locale,
        label,
        date,
        dateFormatOptions,
        isActive
    } = props;

    const prevDateRef = useRef(null);

    const isEmpty = hasEmptyDate(date);
    const isFilled = hasFilledDate(date);

    const wasFilled = hasFilledDate(prevDateRef.current);

    const className = classNames(dateDisplayClassName, {
        [dateDisplayEmptyClassName]: isEmpty,
        [dateDisplayNotEmptyClassName]: !isEmpty,
        [dateDisplayActiveClassName]: isActive
    });

    const labelClassName = classNames(dateDisplayLabelClassName);
    const valueClassName = classNames(dateDisplayValueClassName);

    const value = dateUtils.getLocaleDateString(date, locale, dateFormatOptions);

    const transitionKey = `search-date-display-${date}`;

    const transitionClassNames = {
        enter: classNames(transitionEnterClassName),
        enterActive: classNames(transitionEnterActiveClassName),
        exit: classNames(transitionExitClassName),
        exitActive: classNames(transitionExitActiveClassName)
    };

    const transitionMode = isFilled && wasFilled ? 'out-in' : 'in-out';

    const transitionTimeout = 350;

    prevDateRef.current = date;

    const result = {
        className,
        labelClassName,
        valueClassName,
        label,
        value,
        transitionKey,
        transitionClassNames,
        transitionMode,
        transitionTimeout
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
